import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RouterUtilsCanActivate } from './guards/router-utils.guards';
import { BreadcrumbsService } from './services/breadcrumbs.service';
import { MetaService } from './services/meta.service';
import { RouterUtilsService } from './services/router-utils.service';
import { FilterValueStoreService } from './services/filter-value-store.service';

@NgModule({
  imports: [CommonModule],
  providers: [MetaService, BreadcrumbsService, RouterUtilsService, RouterUtilsCanActivate, FilterValueStoreService],
})
export class PageSettingsModule {}
